import './App.css';
import {
	BrowserRouter as Router,
	Routes,
	Route,
  } from "react-router-dom";
import Home from './component/Home';
import Room from './component/Room';
import Precall from './component/Precall';
import Lobby from './component/Lobby';
import PostCall from './component/PostCall';
import EndOfDiscussion from './component/EndOfDiscussion';
import CreateSesi from './component/CreateSesi';
import Report from './component/Report';

function App() {
  return (
    <div className="App">
      <header className="App-header">
		<Router>
			<Routes>
				<Route exact path='/' element={<Home/>} />
				<Route exact path='/create-session' element={<CreateSesi/>} />
				<Route exact path='/room' element={<Room/>} />
				<Route path='/precall/:link' element={<Precall/>} />
				<Route path='/lobby' element={<Lobby/>} />
				<Route path='/postcall' element={<PostCall/>} />
				<Route path='/finish' element={<EndOfDiscussion/>} />
				<Route path='/report' element={<Report/>} />
			</Routes>
      
    	</Router>
      </header>
    </div>
  );
}

export default App;
